<script>

export default {
  name: 'annotation-description',

  props: {
    annotation: { type: Object, required: true },
    canEdit: { type: Boolean, default: false },
  },

  data() {
    return {
      editedDescription: this.annotation.description,
      editMode: false,
    }
  },

  methods: {
    async save() {
      try {
        let annot = this.annotation.clone();
        annot.description = this.editedDescription;
        annot = await annot.save();

        this.$emit('updateAnnotation', annot);
        this.editMode = false;
      } catch (e) {
        console.log(e);
        this.$notify({type: 'error', text: this.$t('notif-error-update-description')});
      }
    },

    cancel() {
      this.editedDescription = this.annotation.description;
      this.editMode = false;
    }
  }
}
</script>

<template>
  <div>
    <template v-if="editMode && canEdit">
      <b-input v-model="editedDescription" rows="3" type="textarea" />
      <div class="buttons are-small" style="margin-top: 0.5em;">
        <button class="button" @click="save">
          {{ $t('button-save') }}
        </button>
        <button class="button" @click="cancel">
          {{ $t('button-cancel') }}
        </button>
      </div>
    </template>
    <template v-else-if="annotation.description">
      <div style="white-space: pre-line;">
        {{ annotation.description }}
      </div>
      <div class="buttons are-small">
        <button class="button" v-if="canEdit" @click="editMode = true">
          {{ $t('button-edit') }}
        </button>
      </div>
    </template>
    <template v-else>
      <em>{{ $t('no-description') }}</em>
      <button v-if="canEdit" class="button is-small" style="margin-left: 0.5em;" @click="editMode = true">
        {{ $t('button-add') }}
      </button>
    </template>
  </div>
</template>

